<template>
    <div class="card mb-25 border-0 rounded-0 bg-white add-user-card">
        <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
            <Form @submit="updateDemandePrix" :validation-schema="demandePrixSchema">
                <div class="row">
                    <div class="col-md-6">
                        <div class="form-group mb-15 mb-sm-20 mb-md-25">
                            <label class="d-block text-black fw-semibold mb-10">
                                Fournisseur <span class="text-danger">*</span>
                            </label>
                            <Field name="fournisseur" v-slot="{ field, errorMessage }" :value="formData.fournisseur">
                                <Multiselect 
                                    :options="fournisseurOptions" 
                                    :searchable="true" 
                                    track-by="value" 
                                    label="label"
                                    v-model="formData.fournisseur" 
                                    value-prop="value" 
                                    :object="true"
                                    placeholder="Sélectionner le fournisseur"
                                    :class="{ 'is-invalid': errorMessage }"
                                    @change="field.onChange"
                                />
                                <ErrorMessage name="fournisseur" class="invalid-feedback" />
                            </Field>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group mb-15 mb-sm-20 mb-md-25">
                            <label class="d-block text-black fw-semibold mb-10">Date de mouvement</label>
                            <Field name="dateDdp" type="date" v-model="formData.dateDdp"
                                class="form-control shadow-none fs-md-15 text-black" />
                        </div>
                    </div>

                    <div class="tab-content" id="myTabContent">
                        <div class="tab-pane fade show active p-10" id="home-tab-pane" role="tabpanel" tabindex="0">
                            <div class="row">
                                <div class="border border-primary mb-10">
                                    <div class="row d-flex align-items-center justify-content-between fw-bold py-2"
                                        style="background-color: #0a59a4">
                                        <div class="col-md-7">
                                            <h3 class="fs-4 text-white">Produit</h3>
                                        </div>
                                        <div class="col-md-5">
                                            <div class="d-flex float-end">
                                                <button
                                                    class="default-btn me-20 transition border-0 fw-medium text-white pt-2 pb-2 ps-8 pe-8 rounded-1 fs-md-13 fs-lg-14 bg-success"
                                                    type="button" :class="{ 'cursor-not-allowed': isDisable }"
                                                    :disabled="isDisable" @click="addRowProduit()">
                                                    <i class="fa fa-plus-circle"></i>
                                                    Ajout un produit
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div>
                                    <div class="row d-flex align-items-center justify-content-between mt-10">
                                        <div class="col-md-5">
                                            <label class="d-block text-black fw-semibold mb-10">
                                                Produit <span class="text-danger">*</span>
                                            </label>
                                        </div>
                                        <div class="col-md-2">
                                            <label class="d-block text-black fw-semibold mb-10">
                                                Quantité <span class="text-danger">*</span>
                                            </label>
                                        </div>
                                        <div class="col-md-3">
                                            <label class="d-block text-black fw-semibold mb-10">
                                                Prix Unitaire
                                            </label>
                                        </div>
                                        <div class="col-md-2">
                                            <label class="d-block text-black fw-semibold mb-10">Action</label>
                                        </div>
                                    </div>
                                    <hr class="mt-0" />

                                    <div class="row" v-for="(produit, index) in produits" :key="index">
                                        <div class="col-md-5">
                                            <div class="">
                                                <Multiselect :options="produitOptions" :searchable="true"
                                                    track-by="value"  label="label"
                                                    v-model="produit.produit" placeholder="Sélectionner le produit"
                                                    @select="selectProd(produit.produit, produit)" />
                                            </div>
                                        </div>
                                        <div class="col-md-2">
                                            <div class="form-group mb-15 mb-sm-20 mb-md-25">
                                                <input type="number" v-model="produit.qtite" :class="valideteRowProduit(produit.qtite)
                                                    ? 'form-control shadow-none fs-md-15 text-black is-invalid '
                                                    : 'form-control shadow-none fs-md-15 text-black '
                                                    " placeholder="Entrer la quantité" />
                                            </div>
                                        </div>
                                        <div class="col-md-3">
                                            <div class="form-group mb-15 mb-sm-20 mb-md-25">
                                                <input type="number" v-model="produit.prixUnitaireProduit"
                                                    class="form-control shadow-none fs-md-15 text-black"
                                                    placeholder="Prix unitaire" step="0.01" />
                                            </div>
                                        </div>
                                        <div class="col-md-2">
                                            <button class="btn btn-danger transition border-0 pb-2 ps-8 pe-8"
                                                type="button" @click="removeRowProduit(index)">
                                                <i class="fa fa-trash-o lh-1 me-1 position-relative top-2"></i>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-md-12 mt-3">
                    <div class="d-flex align-items-center">
                        <button class="btn btn-success me-3" type="submit" :disabled="isDisable"
                            :class="{ 'cursor-not-allowed': isDisable }">
                            Modifier la demande
                        </button>
                        <router-link to="/demandes-prix/liste-demande-prix" class="btn btn-danger">
                            <i class="fa fa-times lh-1 me-1 position-relative top-2"></i>
                            <span class="position-relative"></span>
                            Annuler
                        </router-link>
                    </div>
                </div>
            </Form>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent, ref, watch, onMounted, reactive } from 'vue';
import ApiService from '@/services/ApiService';
import * as Yup from 'yup';
import { hideModal, error, success } from '@/utils/utils';
import { DemandePrix } from '@/models/DemandePrix';
import { useRouter, useRoute } from 'vue-router';
import Multiselect from '@vueform/multiselect';
import axios from 'axios';
import { Form, Field, ErrorMessage, useFieldArray, useForm } from "vee-validate";
import { Produit, ProduitDepot } from "@/models/Produit";

export default defineComponent({
    name: "EditDemandePrix",
    components: {
        Form,
        Field,
        ErrorMessage,
        Multiselect
    },
    props: {
        item: {
            type: Number,
            default: 0,
        }
    },
    setup(props, { emit }) {
        const demandePrixSchema = Yup.object().shape({
            fournisseur: Yup.object().nullable().required('Le fournisseur est obligatoire'),
            dateDdp: Yup.date().required('La date est obligatoire'),
        });

        // Initialiser le formulaire avec useForm
        const { setFieldValue, values } = useForm({
            validationSchema: demandePrixSchema,
            initialValues: {
                fournisseur: null,
                dateDdp: ''
            }
        });

        interface Option {
            value: number | string;
            label: string;
        }
        const DemandePrixForm = ref<DemandePrix | null>(null);
        const router = useRouter();
        const route = useRoute();
        const demandePrixId = ref(route.params.id);
        
        // Vérifier que l'ID est présent
        if (!demandePrixId.value) {
            error("ID de demande de prix manquant");
            router.push({ name: "ListeDemandePrix" });
            return;
        }
        const demandePrixOptions = ref([]);
        const produitForm = ref<Produit | null>(null);
        const fournisseurOptions = ref<Option[]>([]);

        // formulaire dynamique start
        const montantTotal = ref(0);
        const isDisable = ref(true);
        const produits = reactive([
            {
                produit: "",
                qtite: 0,
                prixUnitaireProduit: 0,
            },
        ]);

        const addRowProduit = () => {
            produits.push({
                produit: "",
                qtite: 0,
                prixUnitaireProduit: 0,
            });
        };

        const removeRowProduit = (index) => {
            if (produits.length > 1) produits.splice(index, 1);
            totals();
        };

        const valideteRowProduit = (e) => {
            if (e == "" || e == 0 || e == "0" || e == null || e < 0) {
                return true;
            } else {
                return false;
            }
        };

        const totals = () => {
            montantTotal.value = 0;
            Object.keys(produits).forEach(function (key) {
                if (produits[key].montant != null) {
                    montantTotal.value += parseFloat(produits[key].montant);
                }
            });
        };

        watch(produits, (newValue, oldValue) => {
            Object.keys(newValue).forEach(function (key) {
                if (newValue[key].produit == "" || newValue[key].qtite == "") {
                    isDisable.value = true;
                } else {
                    isDisable.value = false;
                }
            });
        });

        const { remove, push, fields, update } = useFieldArray("produits");
        const produitOptions = ref<Option[]>([]);
        const prixProd = ref();
        const produitsss: any = ref(null);
        const valuess = ref();

        const fetchProduits = async () => {
            try {
                const response = await axios.get("/all/produitconditionnements");
                const produitsData = response.data.data;
                produitsss.value = produitsData;

                if (produitsData && Array.isArray(produitsData)) {
                    produitOptions.value = produitsData.map((produitconditionnements) => ({
                        value: produitconditionnements.id + "|" +
                            (produitconditionnements.produit?.refProd || '') + "|" +
                            `${produitconditionnements.produit?.nomProd || ''} [ ${produitconditionnements.conditionnement?.libelle || ''} ]` +
                            "|" + (produitconditionnements.prixVenteHt || 0) + "|" +
                            (produitconditionnements.prixVenteTtc || 0),
                        label: `${produitconditionnements.produit?.nomProd || ''} [${produitconditionnements.conditionnement?.libelle || ''}] - ${produitconditionnements.produit?.refProd || ''}`,
                    }));
                } else {
                    produitOptions.value = [];
                }
            } catch (error) {
                console.error('Erreur lors du chargement des produits:', error);
                produitOptions.value = [];
            }
        };

        const idProduit = ref(0);
        const selectProd = async (value: any, produit: ProduitDepot) => {
            console.log("Element", value);
            if (!produit.qtite) {
                produit.qtite = 1;
            }
            totals();
        };

        const formatDate = (dateString: string) => {
            if (!dateString) return "";
            return dateString.split("T")[0];
        };

        interface FormDataType {
            fournisseur: { value: number; label: string } | null;
            dateDdp: string;

        }

        const formData = reactive<FormDataType>({
            fournisseur: null,
            dateDdp: "",
        })
        // Récupérer les données de la demande de prix
        const fetchDemandePrix = async () => {
            try {
                console.log(`Tentative de récupération de la demande de prix avec ID: ${demandePrixId.value}`);
                
                const res = await ApiService.get(`/demandePrixs/${demandePrixId.value}`);
                console.log('Réponse complète du serveur:', res);

                if (res.data.code !== 200 || !res.data.data) {
                    error("Demande de prix introuvable");
                    router.push({ name: "ListeDemandePrix" });
                    return;
                }

                const dp = res.data.data;
                console.log('Données reçues complètes:', dp);
                console.log('Fournisseur:', dp.fournisseur);
                console.log('Date:', dp.dateDdp);
                console.log('Produits:', dp.demandepriprocondis);

                // ---------- Fournisseur ----------
                formData.fournisseur = dp.fournisseur
                    ? {
                        value: dp.fournisseur.id,
                        label: dp.fournisseur.nomFournisseur
                    }
                    : null;

                // Mettre à jour la valeur dans VeeValidate
                setFieldValue('fournisseur', formData.fournisseur);

                // ---------- Date ----------
                formData.dateDdp = formatDate(dp.dateDdp);
                setFieldValue('dateDdp', formData.dateDdp);

                // ---------- Produits ----------
                produits.splice(0); // on vide

                // Vérifier différentes structures possibles pour les produits
                const produitsData = dp.demandepriprocondis || dp.produits || dp.demandePrixProduits || [];
                console.log('Produits trouvés:', produitsData);
                
                if (Array.isArray(produitsData) && produitsData.length > 0) {
                    produitsData.forEach((ligne, index) => {
                        console.log(`Produit ${index}:`, ligne);
                        console.log(`ProduitCondi ${index}:`, ligne.produitcondi);
                        
                        // Adapter selon la structure réelle des données
                        const produitCondi = ligne.produitcondi;
                        
                        const produitString = produitCondi
                            ? `${produitCondi.id}|${ligne.refProd || ""}|${ligne.nomProd || ""}|${produitCondi.prixVenteHt || produitCondi.prixVente || 0}|${produitCondi.prixVenteTtc || 0}`
                            : "";
                            
                        console.log(`Produit string généré ${index}:`, produitString);
                        console.log(`Recherche dans produitOptions pour:`, produitString);
                        
                        // Vérifier si cette valeur existe dans les options
                        const optionTrouvee = produitOptions.value.find(opt => opt.value === produitString);
                        console.log(`Option trouvée:`, optionTrouvee);
                        
                        produits.push({
                            produit: produitString,
                            qtite: Number(ligne.qtite) || 0,
                            prixUnitaireProduit: Number(ligne.prixUnitaireProduit) || 0,
                        });
                    });
                } else {
                    // Si pas de produits, ajouter une ligne vide
                    produits.push({
                        produit: "",
                        qtite: 0,
                        prixUnitaireProduit: 0,
                    });
                }

                isDisable.value = false;

            } catch (err) {
                console.error('Erreur détaillée:', err);
                console.error('Status:', err.response?.status);
                console.error('Data:', err.response?.data);
                console.error('Headers:', err.response?.headers);
                
                // Afficher les erreurs détaillées du serveur
                if (err.response?.data?.errors) {
                    console.error('Erreurs serveur détaillées:', err.response.data.errors);
                    
                    // Convertir les erreurs en chaîne lisible
                    const errorDetails = Object.entries(err.response.data.errors)
                        .map(([key, value]) => `${key}: ${JSON.stringify(value)}`)
                        .join('\n');
                    
                    console.error('Erreurs formatées:', errorDetails);
                }
                
                if (err.response?.status === 404) {
                    error("Demande de prix introuvable (ID: " + demandePrixId.value + ")");
                } else if (err.response?.status === 500) {
                    const serverMessage = err.response?.data?.message || "Erreur serveur";
                    const errorDetails = err.response?.data?.errors ? 
                        '\n\nDétails: ' + JSON.stringify(err.response.data.errors, null, 2) : '';
                    
                    error(`Erreur serveur: ${serverMessage}${errorDetails}`);
                    
                    // Afficher aussi dans la console pour le développeur
                    console.error('Message serveur:', serverMessage);
                    if (err.response?.data?.errors) {
                        console.table(err.response.data.errors);
                    }
                } else if (err.response?.data?.message) {
                    error(err.response.data.message);
                } else {
                    error("Erreur lors du chargement de la demande de prix");
                }
                
                // Ne pas rediriger automatiquement pour permettre le debug
                // router.push({ name: "ListeDemandePrix" });
            }
        };


        const updateDemandePrix = async (values, { resetForm }) => {
            try {
                // Préparer les données à envoyer
                const dataToSend = {
                    fournisseurId: formData.fournisseur?.value || null,
                    dateDdp: formData.dateDdp,
                    produits: produits.map(produit => {
                        const produitParts = (produit.produit && typeof produit.produit === 'string') ?
                            produit.produit.split("|") : ['', '', '', '0', '0'];

                        return {
                            produitId: produitParts[0] || null,
                            qtite: Number(produit.qtite) || 0,
                            nomProd: produitParts[2] || '',
                            refProd: produitParts[1] || '',
                            prixUnitaireProduit: Number(produit.prixUnitaireProduit) || 0,
                        };
                    }).filter(p => p.produitId && p.qtite > 0) // Filtrer les produits valides
                };

                console.log('Données envoyées=>', dataToSend);

                const response = await ApiService.put(`/demandePrixs/${demandePrixId.value}`, dataToSend);

                if (response.data.code == 200) {
                    success(response.data.message);
                    router.push({ name: "ListeDemandePrix" });
                } else {
                    error(response.data.message || 'Erreur lors de la modification');
                }
            } catch (err) {
                console.error('Erreur lors de la modification:', err);
                if (err.response?.data?.message) {
                    error(err.response.data.message);
                } else if (err.response?.data?.errors) {
                    // Gestion des erreurs de validation
                    const errorMessages = Object.values(err.response.data.errors).flat().join(', ');
                    error(`Erreurs de validation: ${errorMessages}`);
                } else {
                    error('Erreur lors de la modification de la demande de prix');
                }
            }
        };

        const fetchFournisseur = async () => {
            try {
                const response = await ApiService.get("all/fournisseurs");
                const fournisseurData = response.data.data?.data || response.data.data;

                if (fournisseurData && Array.isArray(fournisseurData)) {
                    fournisseurOptions.value = fournisseurData.map((fournisseur) => ({
                        value: fournisseur.id,
                        label: `${fournisseur.nomFournisseur || ''}`,
                    }));
                } else {
                    fournisseurOptions.value = [];
                }
            } catch (error) {
                console.error('Erreur lors du chargement des fournisseurs:', error);
                fournisseurOptions.value = [];
            }
        };

        onMounted(async () => {
            console.log('Composant monté avec ID:', demandePrixId.value);
            
            fetchFournisseur();
            fetchProduits();
            
            // Charger directement les données sans vérification préalable
            if (demandePrixId.value) {
                fetchDemandePrix();
            }
        });

        return {
            demandePrixSchema,
            updateDemandePrix,
            DemandePrixForm,
            demandePrixOptions,
            fournisseurOptions,
            produits,
            removeRowProduit,
            addRowProduit,
            valideteRowProduit,
            montantTotal,
            valuess,
            idProduit,
            produitOptions,
            prixProd,
            selectProd,
            isDisable,
            formData,
            setFieldValue
        };
    },
});
</script>

<style scoped>
.cursor-not-allowed {
    cursor: not-allowed;
}

.marge-droite {
    margin-left: 150px;
}

.hr-longeur {
    width: 80%;
}

.bord1 {
    border: 1px solid #07a;
}

.fond {
    background-color: rgb(94, 191, 233);
}
</style>